<div class="col-md-12 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 row m-0 lob-padding">
  <div class="col-md-9 col-sm-12 col-lg-9 col-xl-9 col-xs-9 selectBy-label-padding" style="align-items: center;">
    <mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="selectionTypeChange($event)">
      @for (tab of tabs; track tab) {
      <mat-tab [label]="tab.label"> </mat-tab>
      }
    </mat-tab-group>
  </div>
  <div class="stk-nav col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xs-3 p-0">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb breadcrumb-rightAlign" style="margin-bottom: 0px; padding: 1.5% 0px 0px 0px;">
        <li class="breadcrumb-item"><a class="breadcrumb-home" [routerLink]="['/landing-page']">Home</a></li>
        @if (selectedOption==='lob') {
        <li class="breadcrumb-item active" aria-current="page">LOB Maintenance</li>
        } @if (selectedOption==='org') {
        <li class="breadcrumb-item active" aria-current="page">Organization Maintenance</li>
        } @if (selectedOption==='decom_lob') {
        <li class="breadcrumb-item active" aria-current="page">Decom LOB</li>
        }
        <div>
          <button
            [attr.Pixel-tracking]="true"
            [attr.Pixel-title]="'Documentation'"
            class="breacrum-info-button uitk-icon uitk-icon-info_hollow health md-icon for-media excelandinfo-Icon-font info-icon"
            matTooltipPosition="left"
            title="Info"
            (click)="showInfo()"
          ></button>
        </div>
      </ol>
    </nav>
  </div>
</div>

<div [hidden]="selectedOption != 'lob' && !showLoader">
  <div class="lob-model-view">
    <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
      <div class="uitk-c-card uhc-font">
        <div class="uitk_new_header">
          <div class="uitk-l-grid__col--12 stk-container-tabl-header">
            <div class="stk-header-action row">
              <div class="table-header-icons col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12">
                @if (dataSourceDetails && dataSourceDetails.data.length) {
                <div class="table-search col-md-4 col-sm-6 col-lg-4 col-xl-4 col-xs-6">
                  <mat-form-field class="data-filter" appearance="outline" style="padding: 0px;">
                    <input
                      [(ngModel)]="searchField"
                      matInput
                      type="text"
                      class="capability-search"
                      placeholder="Search Segment/LOB/SubLOB/Architect Names"
                      (keyup)="searchDataSet($event)"
                    />
                    <img src="../../../../assets/images/searchicon.png" class="lob-view-search-img" />
                  </mat-form-field>
                </div>
                } &nbsp;
                <div class="table-header-icons table-header-icons-buttons col-md-8 col-sm-6 col-lg-8 col-xl-8 col-xs-6">
                  @if (TABLE_CONFIG.edit && dataSourceDetails && dataSourceDetails.data.length) {
                  <button
                    (click)="AddNewEntry()"
                    class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                  >
                    Add
                  </button>
                  } @if (TABLE_CONFIG.edit && dataSourceDetails && dataSourceDetails.data.length) {
                  <div>
                    <button
                      (click)="showAddRemoveCAPopup()"
                      class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                    >
                      Add / Remove CA/AD
                    </button>
                  </div>
                  } @if (dataSourceDetails && dataSourceDetails.data.length) {
                  <button
                    (click)="expandAllFunc()"
                    class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                  >
                    {{ allRowsExpanded ? 'Collapse All' : 'Expand All' }}
                  </button>
                  } &nbsp; @if (dataSourceDetails && dataSourceDetails.data.length) {
                  <div (click)="exportToCsv()" class="export-link">
                    <span
                      title="Click to Download"
                      class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"
                    ></span>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="uitk-c-card__content" style="margin-top: 0px !important;">
          <div class="stk-table-container">
            @if (showLoader) {
            <div class="stk-table-loader">
              <app-loader> </app-loader>
            </div>
            } @if (partialLoader) {
            <div class="stk-table-loader partial-loader">
              <app-loader> </app-loader>
            </div>
            } @if (lobLoader) {
            <div class="stk-table-loader lob-loader">
              <app-loader> </app-loader>
            </div>
            } @if (!showLoader) {
            <app-maintenance-table-v4
              [TABLE_CONFIG]="TABLE_CONFIG"
              [COLUMNS]="TABLE_COLUMNS"
              [expanded_columns]="expanded_columns"
              (reloadData)="handleAppicationload()"
              [SORT_CONFIG]="sortConfig"
              [dataSource]="dataSourceDetails"
              [childDataSource]="dataSourceDetails"
              [SCHEMA]="DATA_SCHEMA"
              (searchEvent)="searchEvent($event)"
              (saveEvent)="saveEvent($event)"
              (CreateEvent)="CreateEvent($event)"
              (checkBoxEvent)="checkBoxEvent($event)"
              [pageSize]="TABLE_CONFIG.pageSize"
              [pageIndex]="TABLE_CONFIG.pageIndex"
              [expandAll]="expandAll"
              [exportToExcel]="exportToExcel"
              [selectedOption]="selectedOption"
              (columnDataSubLob)="subLobEditClicked($event)"
              (collapseAll)="collapseAllFunc($event)"
              (ColomnDataLob)="LobEditClicked($event)"
              (loadDeletePopup)="loadDeletePopup($event)"
            >
            </app-maintenance-table-v4>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div [hidden]="selectedOption != 'org'">
  <app-org-maintenance-v4></app-org-maintenance-v4>
</div>
@if (selectedOption=='decom_lob' && decomAccessLoaded) {
<div>
  <app-decom-lob [DecomLobViewAccess]="DecomLobViewAccess" [DecomLobEditAccess]="DecomLobEditAccess"></app-decom-lob>
</div>
}

<app-modal
  [maximizable]="true"
  [inViewport]="true"
  #modalAddLob
  class="modal-demo  lob-add-edit-popups"
  (closeModal)="hidepopup('add')"
>
  <ng-container class="app-modal-header">Add LOB / Sub LOB</ng-container>
  <ng-container class="app-modal-body">
    @if (isNewClicked) {
    <app-lob-add-popup
      [isNewClicked]="isNewClicked"
      [dataSource]="dataSourceFull"
      (AddLobDataEmitter)="applyAddLob($event)"
    >
    </app-lob-add-popup>
    }
  </ng-container>
</app-modal>

<app-modal
  [maximizable]="true"
  [inViewport]="true"
  #modalEditSubLob
  class="modal-demo lob-add-edit-popups"
  (closeModal)="hidepopup('editSubLob')"
>
  <ng-container class="app-modal-header">Edit Sub LOB</ng-container>
  <ng-container class="app-modal-body">
    @if (isSubLobEditClicked) {
    <app-lob-add-popup
      [isSubLobEditClicked]="isSubLobEditClicked"
      [EditColumnDataSubLob]="EditColumnDataSubLob"
      (EditSubLobDataEmitter)="applyEditSubLob($event)"
      (clearSearch)="searchClear()"
    >
    </app-lob-add-popup>
    }
  </ng-container>
</app-modal>

<app-modal
  [maximizable]="true"
  [inViewport]="true"
  #modalEditLob
  class="modal-demo lob-edit"
  (closeModal)="hidepopup('editLob')"
>
  <ng-container class="app-modal-header">Edit LOB</ng-container>
  <ng-container class="app-modal-body">
    @if (isLobEditClicked) {
    <app-lob-add-popup
      [isLobEditClicked]="isLobEditClicked"
      [EditColumnDataLob]="EditColumnDataLob"
      (EditLobDataEmitter)="applyEditLob($event)"
    >
    </app-lob-add-popup>
    }
  </ng-container>
</app-modal>

<app-modal
  [maximizable]="true"
  [inViewport]="true"
  #deleteModel
  class="modal-delete"
  (closeModal)="hidepopup('deleteSubLob')"
>
  @if (isDeleteClicked) {
  <ng-container class="app-modal-header">Delete Sub LOB : {{ deleteSelectedSubLob.SubLineofBusiness }}</ng-container>
  }
  <ng-container class="app-modal-body">
    @if (isDeleteClicked) {
    <app-delete-lob
      [isDeleteClicked]="isDeleteClicked"
      [deletedRow]="deleteSelectedSubLob"
      [lobDatasource]="dataPersistObj.data"
      (deleteSuccessEvent)="hideDeletePopup()"
    >
    </app-delete-lob>
    }
  </ng-container>
</app-modal>

<app-modal
  [maximizable]="true"
  [inViewport]="true"
  #bulkModel
  class="modal-delete"
  (closeModal)="hidepopup('bulkEdit')"
>
  @if (isBulkClicked) {
  <ng-container class="app-modal-header">Bulk Edit</ng-container>
  }
  <ng-container class="app-modal-body">
    @if (isBulkClicked) {
    <app-lob-bulk-edit (bulkSuccessEvent)="hideBulkPopup()"> </app-lob-bulk-edit>
    }
  </ng-container>
</app-modal>

<app-modal
  id="addRemoveCAModel"
  [maximizable]="true"
  [inViewport]="true"
  #addRemoveCAModel
  class="modal-delete"
  (closeModal)="hidepopup('addRemoveCA')"
>
  @if (isAddRemoveClicked) {
  <ng-container class="app-modal-header">Add / Remove CA/AD</ng-container>
  }
  <ng-container class="app-modal-body">
    @if (isAddRemoveClicked) {
    <app-add-remove-popup
      (addRemoveSuccessEvent)="hideaddRemovePopup()"
      [dataSource]="dataSourceFull"
      [popupName]="'AddRemoveArchitect'"
      [clearFormFields]="clearFormFields"
    >
    </app-add-remove-popup>
    }
  </ng-container>
</app-modal>
